import { Box, Button, CircularProgress, IconButton, Paper, Tooltip, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import React, { useMemo } from 'react'

import successImg from '../../../assets/success.svg'
import { Icons } from '../../../utils/utilities'

export default function ReattemptRequestApproved ( { onCta, waiting = false } ) {

    const { pathname } = useLocation()
    const { t } = useTranslation()

    const thankyouPage = useMemo( () => pathname.match( /(thankyou)\/?$/ ), [pathname] )

    return (
        <Box component={Paper} sx={{ borderRadius: "10px", padding: "20px", maxWidth: "400px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }} >

                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }} >``
                    <Box component="img" marginBottom="10px" src={successImg} width="160px" alt="Request approved" />
                    <Typography variant='h6' lineHeight={1.1} textAlign="center" sx={{ fontSize: "1.6rem" }}>{t( 'candidateLogin.reattempApproved' )}</Typography>
                    <Typography variant='subtitle2' textAlign="center" color='textSecondary' sx={{ fontSize: "0.875rem" }}>{t( 'candidateLogin.reattempApprovedSubtext' )}</Typography>
                </Box>

                <Box>
                    <Button type='button' onClick={onCta} sx={{ textTransform: "capitalize", py: 1, px: 2 }} disableElevation disabled={waiting} endIcon={waiting ? <CircularProgress size={14} /> : Icons.default.ArrowForward} size='small' variant='contained' >{waiting ? t( 'button.attempting' ) : t( 'button.attempt' )}</Button>
                </Box>

            </Box>

        </Box>
    )
}
